import React from 'react';
import { cn } from '../../lib/utils';

interface KYPSearchTabsProps {
  activeTab: 'search' | 'history';
  setActiveTab: (tab: 'search' | 'history') => void;
}

export const KYPSearchTabs: React.FC<KYPSearchTabsProps> = ({
  activeTab,
  setActiveTab
}) => {
  return (
    <div className="flex border-b border-gray-700 mb-4">
      <button
        className={cn(
          "px-4 py-2 font-medium text-sm",
          activeTab === 'search'
            ? "text-[#4E46FF] border-b-2 border-[#4E46FF]"
            : "text-[#CECFD2] hover:text-[#4E46FF]"
        )}
        onClick={() => setActiveTab('search')}
      >
        Search
      </button>
      <button
        className={cn(
          "px-4 py-2 font-medium text-sm",
          activeTab === 'history'
            ? "text-[#4E46FF] border-b-2 border-[#4E46FF]"
            : "text-[#CECFD2] hover:text-[#4E46FF]"
        )}
        onClick={() => setActiveTab('history')}
      >
        Historical Searches
      </button>
    </div>
  );
};